import { withDefaultProps } from '@/lib/with-default-props';

import { Link } from '../link';

export const BlankLink = withDefaultProps(Link, {
  variant: 'blank',
});
